import { Component, OnInit } from '@angular/core';
import { NotificationsService } from '../../services/notifications.service';
import { NotificationListModel } from '../../models/notification-list.model';
import { SharedToasterService } from '../../../shared/services/shared-toaster.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ConfirmationModalComponent } from '@premotec/pmt-bootstrap';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-notifications-list',
    templateUrl: './notifications-list.component.html',
    styleUrl: './notifications-list.component.scss'
})
export class NotificationsListComponent implements OnInit {
    protected displayedNotifications: NotificationListModel[] | null = null;

    protected isPreLoading = false;

    private preLoadedNotifications: NotificationListModel[] | null = null;
    private batchSize = 10;

    constructor(
        private notificationService: NotificationsService,
        private sharedToasterService: SharedToasterService,
        private bsModalService: BsModalService,
        private translocoService: TranslocoService,
    ) { }

    ngOnInit(): void {
        this.loadNotificationsList(0);
        this.preLoadNotificationsList(this.batchSize);
    }

    protected get hasMore(): boolean {
        if (this.preLoadedNotifications == null) return false;
        return (this.preLoadedNotifications.length > 0);
    }

    protected loadMoreNotifications(): void {
        if (!this.hasMore) return;
        if (this.displayedNotifications == null) return;
        if (this.preLoadedNotifications == null) return;

        this.displayedNotifications.push(... this.preLoadedNotifications);

        this.preLoadNotificationsList(this.displayedNotifications.length);
    }

    private loadNotificationsList(skip: number): void {
        this.displayedNotifications = null;

        this.notificationService.getNotifications(skip, this.batchSize).subscribe({
            next: (res) => {
                const items = res ?? [];
                this.displayedNotifications = items.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
            },
            error: () => {
                this.sharedToasterService.showGeneralDataLoadingError();
            }
        });
    }

    private preLoadNotificationsList(skip: number): void {
        this.preLoadedNotifications = null;

        this.notificationService.getNotifications(skip, this.batchSize).subscribe({
            next: (res) => {
                const items = res ?? [];
                this.preLoadedNotifications = items.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
            },
            error: () => {
                this.sharedToasterService.showGeneralDataLoadingError();
            }
        });
    }

    protected markNotificationsAsRead(): void {
        let bsModalRef = this.bsModalService.show(ConfirmationModalComponent, {
            ignoreBackdropClick: true,
            initialState: {
                body: this.translocoService.translate('inbox.notifications.markAllAsRead.question')
            }
        });

        bsModalRef.content?.confirmed.subscribe({
            next: () => {
                this.bsModalService.hide();
                this.notificationService.markNotificationsAsRead().subscribe({
                    next: () => {
                        window.location.reload();
                    },
                    error: () => {
                        this.sharedToasterService.showGeneralSavingError();
                    }
                });
            }
        });
    }
}
